import { useState } from "react";
import { nriUrgencyData, nriWhatsappUrl } from "../../data/nriTaxData";
import { AlertTriangle, ChevronDown, ArrowRight } from "lucide-react";

const DeadlineRow = ({ deadline, index }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`border transition-all duration-300 rounded-sm overflow-hidden ${open ? "border-red-500/30 bg-[#302f2c]/50" : "border-red-500/15 bg-[#1a1c1b] hover:border-red-500/25"}`}
      data-testid={`nri-deadline-${index}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-4 px-5 py-5 text-left">
        {/* Alert icon */}
        <div className="w-8 h-8 rounded-md bg-red-500/10 border border-red-500/20 flex items-center justify-center flex-shrink-0">
          <AlertTriangle size={14} className="text-red-400" />
        </div>
        {/* Label + Title */}
        <div className="flex-1 min-w-0">
          <p className="text-red-400/60 text-[10px] font-black uppercase tracking-widest mb-0.5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{deadline.label}</p>
          <p className="text-[#dfddd6] font-bold text-sm leading-snug" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{deadline.title}</p>
        </div>
        <ChevronDown size={15} className={`text-[#888680] flex-shrink-0 transition-transform duration-300 ${open ? "rotate-180 text-red-400" : ""}`} />
      </button>
      <div className="overflow-hidden transition-all duration-300" style={{ maxHeight: open ? "250px" : "0", opacity: open ? 1 : 0 }}>
        <p className="px-5 pb-5 pt-0 pl-[68px] text-[#888680] text-xs leading-relaxed" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{deadline.body}</p>
      </div>
    </div>
  );
};

export const NriUrgencySection = () => (
  <section id="nri-urgency" className="relative py-28" style={{ background: "#252422" }}>
    <div className="absolute top-0 left-0 right-0 h-px bg-[#3f4816]/30" />
    <div className="max-w-[87.5rem] mx-auto px-10">

      {/* Heading */}
      <div className="mb-14">
        <span className="inline-block text-[#888680] text-xs font-medium uppercase tracking-[0.2em] mb-5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {nriUrgencyData.sectionLabel}
        </span>
        <p className="text-[#888680]/60 font-semibold uppercase mb-1" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(0.85rem, 0.7rem + 0.6vw, 1rem)", letterSpacing: "-0.01em" }}>
          3 active deadlines working against
        </p>
        <h2 className="font-black uppercase leading-tight" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.8rem, 1.4rem + 2.5vw, 3.5rem)", letterSpacing: "-0.03em" }}>
          <span className="text-[#d9fb06]">Every NRI</span>
          <span className="text-[#888680]/50"> right now.</span>
        </h2>
      </div>

      {/* Deadline accordions */}
      <div className="flex flex-col gap-2 mb-8 max-w-4xl">
        {nriUrgencyData.deadlines.map((d, i) => <DeadlineRow key={i} deadline={d} index={i} />)}
      </div>

      {/* Scarcity */}
      <div className="max-w-4xl bg-[#302f2c]/50 border border-[#d9fb06]/20 rounded-sm p-6">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-md bg-[#d9fb06]/10 border border-[#d9fb06]/20 flex items-center justify-center flex-shrink-0">
            <AlertTriangle size={17} className="text-[#d9fb06]" />
          </div>
          <div>
            <p className="text-[#dfddd6] font-semibold text-sm mb-1" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              <span className="text-[#d9fb06] font-black">5 clients per month.</span>{" "}
              Each case gets my direct, personal attention.
            </p>
            <p className="text-[#888680] text-xs mb-4" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>I don't delegate cross-border NRI analysis.</p>
            <a href={nriWhatsappUrl} target="_blank" rel="noopener noreferrer" data-testid="nri-urgency-cta"
              className="group inline-flex items-center gap-2 bg-[#d9fb06] text-[#1a1c1b] font-bold text-xs px-6 py-3 rounded-full transition-all duration-300 hover:scale-[1.02] hover:opacity-90 uppercase tracking-tight"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              Claim My Slot — 60 Min
              <ArrowRight size={13} className="transition-transform group-hover:translate-x-0.5 duration-300" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);
